module.exports = __webpack_public_path__ + "img/02.212b7b1a.png";